export default __webpack_public_path__ + "static/media/00.04f41672.jpg";